// Centralized date/time formatting so every tab renders timestamps the same way
// and handles null/invalid values consistently (no scattered inline `new Date()`).

/**
 * Formats an ISO string or Date as a localized date + time.
 * Returns '-' for empty or unparseable values.
 * @param {string | number | Date | null | undefined} value
 * @returns {string}
 */
export function formatDateTime(value) {
  if (!value) return '-';
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? '-' : d.toLocaleString();
}

/**
 * Formats an ISO string or Date as a localized time of day (hh:mm:ss).
 * Returns '-' for empty or unparseable values.
 * @param {string | number | Date | null | undefined} value
 * @returns {string}
 */
export function formatTime(value) {
  if (!value) return '-';
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime())
    ? '-'
    : d.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
}
